import {
  type AltchaWidgetElement,
  makeAltchaBoxClickable,
  setupAltcha,
  waitForAltcha,
} from "../../utils/altcha";

export const initCustomPricing = () => {
  const form = document.getElementById("for-work-contact-form") as HTMLFormElement;

  if (!form) {
    return;
  }

  setupAltcha();

  const altchaWrapper = form.querySelector(".altcha-wrapper") as HTMLDivElement | null;
  const altchaWidget = form.querySelector(
    ".altcha-wrapper altcha-widget",
  ) as AltchaWidgetElement | null;
  const submitButton = form.querySelector(".custom-pricing-submit") as HTMLButtonElement;

  if (!altchaWrapper || !altchaWidget || !submitButton) {
    return;
  }

  makeAltchaBoxClickable(altchaWidget);

  submitButton.addEventListener("click", (e) => {
    e.preventDefault();
    submitButton.disabled = true;

    waitForAltcha(altchaWrapper, altchaWidget)
      .then((payload) => {
        if (!form.checkValidity()) {
          form.reportValidity();
          submitButton.disabled = false;
          return;
        }

        const altchaInput = form.querySelector('input[name="altcha"]') as HTMLInputElement;
        if (altchaInput) {
          altchaInput.value = payload;
        }
        form.submit();
      })
      .catch(() => {
        submitButton.disabled = false;
      });
  });
};
